import React from "react";
import { useState } from "react";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { doSendEmail, actions } from "../forgotPasswordActions";

import { isEmailValid } from "../../../../utils/functions/form";
import { Box, CardContent } from "@mui/material";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import { toast } from "react-toastify";
import { t } from "i18next";

const ForgotPasswordLanding = () => {
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const [validationErrors, setValidationErrors] = useState({});
  const [email, setEmail] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidationErrors({});
    dispatch(actions.setEmailRecover(email));
    const errors = {};

    if (!email) {
      errors.email = t("FieldRequired");
    } else if (!isEmailValid(email)) {
      errors.email = t("InsertValidMail");
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    dispatch(doSendEmail(email)).then((res) => {
      if (res?.payload?.Result === 1) {
        navigate("/login");
        toast.success(t("EmailSent"));
      }
    });
  };

  return (
    <CardContent className="py-12 px-24">
      <h2
        style={{ color: primaryColor }}
        className="font-bold text-4xl w-full mx-auto text-center"
      >
        {t("ForgotPassword")}
      </h2>
      <p className="text-center">{t("NotWorryPasswordInstruction")}</p>

      <Box component="form" className="flex flex-col" onSubmit={handleSubmit}>
        <Box className="flex w-full flex-col items-center mt-2 space-y-8">
          <CoreInputField
            name="email"
            className="w-full"
            required={true}
            value={email}
            onChange={handleChangeEmail}
            label="Email"
            type="email"
            error={Boolean(validationErrors.email)}
            helperText={validationErrors.email}
          />
        </Box>

        <Box className="flex w-full mx-auto mt-16 mb-2 space-x-2">
          <CoreButton
            className="btn-round-outline w-1/2"
            testo={t("Back")}
            onClick={() => navigate("/login")}
          />
          <CoreButton
            className="btn-round w-1/2"
            type="submit"
            testo={t("Send")}
          />
        </Box>
      </Box>
    </CardContent>
  );
};

export default ForgotPasswordLanding;
